import React, {useEffect} from 'react';
import styled from 'styled-components';
import ManageSchedule from "../components/ManageSchedule";
import {liveAPI} from "../../../../api/liveAPI";

const TimeSettings = () => {

return(
  <Container>
    <ManageSchedule />
  </Container>
)

}
export default TimeSettings;

const Container = styled.div`
    
`;